import ApiService from "@/services/api.service";
import logger from "@/utils/logger";

/**
 * Send a WhatsApp notification via Twilio (server uses TWILIO_* env), optional SMS.
 * @param {string} message
 * @param {boolean} [sendSMS=false]
 * @param {{ to?: string, toSms?: string, companyId?: string|number }} [opts] — optional per-company defaults from Settings
 * @returns {Promise<unknown>}
 */
export async function sendWhatsApp(message, sendSMS = false, opts = {}) {
  const { to, toSms, companyId } = opts && typeof opts === "object" ? opts : {};
  try {
    const response = await ApiService.post("/system/whatsapp/notification", {
      message,
      sendSMS,
      ...(to != null && to !== "" ? { to } : {}),
      ...(toSms != null && toSms !== "" ? { toSms } : {}),
      ...(companyId != null && companyId !== "" ? { companyId } : {}),
    });
    logger.log("WhatsApp message sent:", response.data);
    return response.data;
  } catch (err) {
    logger.error("Failed to send WhatsApp message:", {
      message: err?.message,
      status: err?.response?.status,
      data: err?.response?.data,
    });
    throw err;
  }
}
